import { useTranslation } from 'react-i18next';
import { HiMagnifyingGlass, HiSparkles, HiCheck } from 'react-icons/hi2';
import {
  Section,
  Container,
  Visual,
  SearchBar,
  SearchInput,
  SearchIcon,
  SearchQuery,
  ResultsList,
  ResultItem,
  ResultTitle,
  ResultMeta,
  ResultBadge,
  ResultHighlight,
  ResultSnippet,
  LabelsDemo,
  LabelsTitle,
  LabelsGrid,
  LabelTag,
  Content,
  Label,
  Title,
  Description,
  FeatureList,
  FeatureItem,
  FeatureIcon,
} from './AISearch.styled';

export default function AISearch() {
  const { t } = useTranslation();

  const features = t('aiSearchSection.features', { returnObjects: true }) as string[];

  return (
    <Section id="ai-search">
      <Container>
        <Visual>
          <SearchBar>
            <SearchInput>
              <SearchIcon>
                <HiMagnifyingGlass size={16} />
              </SearchIcon>
              <SearchQuery>{t('aiSearchSection.searchDemo.query')}</SearchQuery>
            </SearchInput>
            <ResultsList>
              <ResultItem>
                <ResultTitle>{t('aiSearchSection.searchDemo.results.0.title')}</ResultTitle>
                <ResultMeta>
                  <ResultBadge $variant="blue">{t('aiSearchSection.searchDemo.results.0.badge')}</ResultBadge>
                  <span>{t('aiSearchSection.searchDemo.results.0.case')}</span>
                </ResultMeta>
                <ResultSnippet>
                  ...{t('aiSearchSection.searchDemo.results.0.snippetBefore')}<ResultHighlight>{t('aiSearchSection.searchDemo.results.0.highlight')}</ResultHighlight>{t('aiSearchSection.searchDemo.results.0.snippetAfter')}...
                </ResultSnippet>
              </ResultItem>
              <ResultItem>
                <ResultTitle>{t('aiSearchSection.searchDemo.results.1.title')}</ResultTitle>
                <ResultMeta>
                  <ResultBadge $variant="amber">{t('aiSearchSection.searchDemo.results.1.badge')}</ResultBadge>
                  <span>{t('aiSearchSection.searchDemo.results.1.case')}</span>
                </ResultMeta>
              </ResultItem>
              <ResultItem>
                <ResultTitle>{t('aiSearchSection.searchDemo.results.2.title')}</ResultTitle>
                <ResultMeta>
                  <ResultBadge $variant="green">{t('aiSearchSection.searchDemo.results.2.badge')}</ResultBadge>
                  <span>{t('aiSearchSection.searchDemo.results.2.case')}</span>
                </ResultMeta>
              </ResultItem>
            </ResultsList>
          </SearchBar>

          <LabelsDemo>
            <LabelsTitle>
              <HiSparkles size={12} style={{ display: 'inline', verticalAlign: 'middle', marginRight: 4 }} />
              {t('aiSearchSection.labelsDemo.title')}
            </LabelsTitle>
            <LabelsGrid>
              <LabelTag $color="#1E3A8A" $bg="#DBEAFE">{t('aiSearchSection.labelsDemo.tags.0')}</LabelTag>
              <LabelTag $color="#92400E" $bg="#FEF3C7">{t('aiSearchSection.labelsDemo.tags.1')}</LabelTag>
              <LabelTag $color="#065F46" $bg="#D1FAE5">{t('aiSearchSection.labelsDemo.tags.2')}</LabelTag>
              <LabelTag $color="#7C3AED" $bg="#F3E8FF">{t('aiSearchSection.labelsDemo.tags.3')}</LabelTag>
              <LabelTag $color="#BE123C" $bg="#FFE4E6">{t('aiSearchSection.labelsDemo.tags.4')}</LabelTag>
              <LabelTag $color="#0369A1" $bg="#E0F2FE">{t('aiSearchSection.labelsDemo.tags.5')}</LabelTag>
            </LabelsGrid>
          </LabelsDemo>
        </Visual>
        <Content>
          <Label>{t('aiSearchSection.label')}</Label>
          <Title>{t('aiSearchSection.title')}</Title>
          <Description>{t('aiSearchSection.description')}</Description>
          <FeatureList>
            {features.map((feature) => (
              <FeatureItem key={feature}>
                <FeatureIcon><HiCheck size={16} /></FeatureIcon>
                {feature}
              </FeatureItem>
            ))}
          </FeatureList>
        </Content>
      </Container>
    </Section>
  );
}
